import FilledImage from "./FilledImage";

export const DarkIcon = ({ size = 94 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 94 94" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="47" cy="47" r="47" fill="#111936" fillOpacity="0.15" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.1332 20C50.777 20 45.4633 25.8845 44.0461 30.0396C41.5601 36.4336 42.6096 41.345 43.5344 45.6764L43.6014 45.9919C44.4602 50.0202 45.2706 53.8248 44.1101 58.6001C44.0023 59.2538 43.8108 59.8967 43.5409 60.511C42.213 63.5562 39.2016 65.5228 35.8699 65.5228C31.2587 65.5228 27.5071 61.7938 27.5071 57.209C27.5071 52.6223 31.2587 48.8909 35.8699 48.8909C37.1118 48.8909 38.3052 49.1571 39.4195 49.6804L40.3907 50.1374L39.1806 42.7828L38.7987 42.706C37.8407 42.5144 36.8551 42.4179 35.8699 42.4179C27.6704 42.4179 21 49.0529 21 57.209C21 65.3654 27.6704 72 35.8699 72C42.6767 72 48.6003 67.4222 50.2664 60.9044C51.951 55.7994 51.1635 51.1417 50.0473 46.0158L49.9224 45.4454C48.8271 40.4322 47.9617 36.4721 50.5711 31.2433C51.9444 28.3477 54.9124 26.4761 58.1332 26.4761C62.7425 26.4761 66.4929 30.2051 66.4929 34.7899C66.4929 39.3743 62.7425 43.1048 58.1332 43.1048C56.9906 43.1048 55.8806 42.8792 54.831 42.4322L53.8877 42.0315L55.0791 49.2739L55.4711 49.3453C56.3419 49.5018 57.238 49.5821 58.1332 49.5821C66.3308 49.5821 73 42.9459 73 34.7899C73 26.6346 66.3308 20 58.1332 20Z"
        fill="white"
        fillOpacity="0.04"
      />
    </svg>
  );
};

export const LoadingDarkImage = (props: { [key: string]: any }) => {
  return <FilledImage Icon={DarkIcon} theme="dark" {...props} />;
};
